export default __webpack_public_path__ + "static/media/WNo.7-1.b159f74d.jpg";